module.exports = __webpack_public_path__ + "static/media/logo.1d5b1364.png";